if (document.body.classList.contains("home") || document.body.classList.contains("top")) {
	const copy01 = document.querySelector("#copy01");
	const copies = document.querySelectorAll(".copies");
	var option = {
		root: null,
		rootMargin: "0px",
		threshold: [0],
	};

	const callback = function (entries, observer) {
		entries.forEach(function (entry) {
			if (entry.isIntersecting) {
				copy01.classList.add("fade-in");
				Array.prototype.forEach.call(copies, function (copy) {
					copy.classList.add("fade-up");
				});
				observer.unobserve(entry.target);
			}
		});
	};

	var observer = new IntersectionObserver(callback, option);
	observer.observe(copy01);
}
